import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const partnerOrgListTableControllerSlice = createSlice({
    name: 'partnerOrgListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = partnerOrgListTableControllerSlice.actions;

export default partnerOrgListTableControllerSlice.reducer;